import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ForgeCardModule } from '@tylertech/forge-angular';

@Component({
  selector: 'app-body-card',
  standalone: true,
  templateUrl: './app-body-card.component.html',
  styleUrls: ['./app-body-card.component.scss'],
  imports: [CommonModule, ForgeCardModule]
})
export class AppBodyCardComponent {
  @Input()
  public headerText?: string;

  @Input()
  public fullWidth = false;
}